import { Box, Button } from "@mui/material";
import React from "react";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import { useNavigate, useParams } from "react-router-dom";
import DynamicPageLayout from "../components/common/DynamicPageLayout";
import { IPageLayoutType } from "../types/pageLayoutTypes";

const SitesLabDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const params = useParams();
  console.debug(params.id);
  const siteDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Number One Hospital",
      caption: "S1001",
      chip: "Recruiting",
      content: [
        {
          label: "Address",
          value: "230 Clinical Drive, Suite 123, New York, NY 12345, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Katie Neil",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "katieneil@email.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "555-555-5555",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const centralLabDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Lab Corp A32",
      caption: "CL1987",
      description: "",
      content: [
        {
          label: "Address",
          value: "230 Clinical Drive, Suite 123, New York, NY 12345, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Amy Hall",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "amy.hall@labcorp.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "789-456-1230",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  const vendorDetailsContentJson: IPageLayoutType[] = [
    {
      title: "Lab Max",
      caption: "VL1002",
      description: "",
      content: [
        {
          label: "Address",
          value: "2999 Best Lab Drive, Suite 100, Pitsburgh, PA 20211, USA",
          size: {
            mediumScreen: 12,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Name",
          value: "Katie Crise",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Email",
          value: "katie.crise@labmax.com",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
        {
          label: "Contact Phone Number",
          value: "123-456-1230",
          size: {
            mediumScreen: 4,
            extraSmallScreen: 12,
          },
        },
      ],
    },
  ];

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate("/sites-lab")}
        >
          Back
        </Button>
      </Box>
      {params?.id?.includes("S") ? (
        <DynamicPageLayout pageContentJson={siteDetailsContentJson} data={{}} />
      ) : params?.id?.includes("C") ? (
        <DynamicPageLayout
          pageContentJson={centralLabDetailsContentJson}
          data={{}}
        />
      ) : (
        <DynamicPageLayout
          pageContentJson={vendorDetailsContentJson}
          data={{}}
        />
      )}
    </>
  );
};

export default SitesLabDetails;
